import { render, staticRenderFns } from "./JVxeImageCell.vue?vue&type=template&id=6086ab8d&scoped=true"
import script from "./JVxeImageCell.vue?vue&type=script&lang=js"
export * from "./JVxeImageCell.vue?vue&type=script&lang=js"
import style0 from "./JVxeImageCell.vue?vue&type=style&index=0&id=6086ab8d&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6086ab8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6086ab8d')) {
      api.createRecord('6086ab8d', component.options)
    } else {
      api.reload('6086ab8d', component.options)
    }
    module.hot.accept("./JVxeImageCell.vue?vue&type=template&id=6086ab8d&scoped=true", function () {
      api.rerender('6086ab8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/JVxeCells/JVxeImageCell.vue"
export default component.exports